import { render, staticRenderFns } from "./InterestsSelect.vue?vue&type=template&id=499bdbc3&scoped=true"
import script from "./InterestsSelect.vue?vue&type=script&lang=js"
export * from "./InterestsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499bdbc3",
  null
  
)

export default component.exports